<template>
  <div>
    <CModal :show.sync="activeBlock" centered :draggable="false">
      <template slot="header-wrapper">
        <div/>
      </template>
      Etes-vous sûrs de vouloir bloquer/débloquer le statut de la sélection ?
      <template slot="footer">
        <CButton color="secondary" class="mr-2" @click="activeBlock = false; selectedIds = []">
          Non
        </CButton>
        <CButton
          color="primary"
          @click="blockCompetences(selectedIds)"
          data-cy="confirm-delete-button"
        >
          Oui
        </CButton>
      </template>
    </CModal>
    <ReferenceTableActions
      table-name="compétence"
      manageButtonContent="Bloquer / Débloquer"
      :buttons="['create', 'template', 'upload', 'manage-button', 'export']"
      :disabledButtons="!selectedIds.length ? ['manage-button'] : []"
      @create="showCreate"
      @template="downloadFile({
                fileName: 'competences_template.xlsx',
                downloadURL: COMPETENCE_ENDPOINTS.template,
             })"
      @upload="uploadCompetences"
      @manage-button="activeBlock = true"
      @export="downloadFile({
          downloadURL: COMPETENCE_ENDPOINTS.export,
          query: $refs.competencesTable.tableQuery
        })"
    />
    <table-component
      :encode-filters="false"
      :filterExcludeColumns="['actions']"
      @row-selected="rowSelected"
      keep-id
      :should-allow-row-selection="true"
      :columns="tableColumns"
      :headings="tableHeadings"
      :url="COMPETENCE_ENDPOINTS.base"
      :pagination-text-position="'bottom'"
      ref="competencesTable"
    >
      <template slot="row-selection-button">
        <div/>
      </template>
      <template slot="code_competence" slot-scope="{ row }">
        {{ row.code_competence }}
      </template>
      <template slot="competence_block" slot-scope="{ row }">
        {{ row.competence_block ? "X" : "" }}
      </template>
      <template slot="actions" slot-scope="{ row }">
        <div class="d-flex flex-wrap" style="row-gap: 0.25em; column-gap: 0.5em">
          <CButton
            class="sm outline action-button"
            color="primary"
            size="sm"
            variant="outline"
            @click="showEdit(row)"
          >
            <em class="fa fa-edit"/>
            Modifier
          </CButton>
        </div>
      </template>
    </table-component>
    <CModal
      :show.sync="showModal"
      :draggable="false"
      :resizable="false"
      centered
    >
      <template slot="header">
        {{ isEdit ? "Modification d'une compétence" : "Création d'une nouvelle compétence" }}
      </template>
      <div class="bg-extended-color44 p-2 mb-2" v-if="!canCreate">
          Required fields are missing
        </div>
      <div class="d-flex flex-column gap-2">
        <MzSelect
          required
          searchable
          label="Certification Code"
          :disabled="isEdit"
          :options="availableCodes"
          :value.sync="newCompetence.certification_code"
        />
        <CInput
          required
          class="danger"
          label="Compétence"
          v-model="newCompetence.competences_fr"
        />
        <CInput
          label="Compétence (EN)"
          v-model="newCompetence.competences_en"
        />
        <CInput
          label="Compétence (ZH)"
          v-model="newCompetence.competences_zh"
        />
      </div>
      <template slot="footer">
        <div>
          <CButton
            color="secondary"
            class="mr-2"
            @click="showModal=false"
          >
            Annuler
          </CButton>
          <CButton
            color="primary"
            :disabled="!canCreate"
            @click="isEdit ? updateCompetence() : createCompetence()"
          >
            Sauvegarder
          </CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
import ReferenceTableActions from "@/components/ReferenceTableActions";
import {COMPETENCE_ENDPOINTS, CompetenceService} from "@/services/competence";
import {CertService} from "@/services/certification";
import {downloadFile} from "@/utils/request";
import {FilesService} from "@/services/files";


export default {
  name: "Competences",
  components: {ReferenceTableActions},
  data() {
    return {
      canCreate: true,
      selectedIds: [],
      isEdit: false,
      showModal: false,
      activeBlock: false,
      isUploading: false,
      availableCodes: [],
      clearCompetence: {
        certification_code: "",
        competences_fr: "",
        competences_en: "",
        competences_zh: "",
      },
      newCompetence: {},
      COMPETENCE_ENDPOINTS,
      tableColumns: [
        "certification_code",
        "code_competence",
        "competences_fr",
        "competences_en",
        "competences_zh",
        "competence_block",
        "actions",
      ],
      tableHeadings: {
        "code_competence": "Code Compétence",
        "competences_fr": "Compétence",
        "competences_en": "Compétence (EN)",
        "competences_zh": "Compétence (ZH)",
        "competence_block": "Compétences bloquées",
      },
    }
  },
  async mounted() {
    this.newCompetence = this.clearCompetence;
  },
  watch: {
    newCompetence: {
      handler() {
        if (this.requiredFieldsFilled) this.canCreate = true
      },
      deep: true
    }
  },
  computed: {
    requiredFieldsFilled() {
      return !!this.newCompetence.certification_code && !!this.newCompetence.competences_fr
    },
  },
  methods: {
    downloadFile,
    async refreshTableData() {
      await this.$refs.competencesTable.$refs.table.getData()
    },
    async blockCompetences(Ids) {
      const {res} = await CompetenceService.blockCompetences(Ids);
      if (res.status !== 200) alert("Something went wrong");
      this.activeBlock = false;
      await this.refreshTableData()
    },
    async uploadCompetences(files) {
      this.isUploading = true;
      await FilesService.uploadFile({
        file: files[0],
        url: COMPETENCE_ENDPOINTS.base  + "upload/",
        onError: (res) => {
          alert(res.detail);
          this.isUploading = false;
        },
        onSuccess: (res) => {
          alert(res.message);
        }
      });
      this.isUploading = false;
      await this.refreshTableData()
    },
    rowSelected(selected) {
      this.selectedIds = selected.map((competence) => competence._id)
    },
    showEdit(competence) {
      this.showModal = true
      this.isEdit = true
      this.newCompetence = {...competence};
    },
    async showCreate() {
      this.canCreate = true
      const {data} = await CertService.getAvailableCodes();
      this.availableCodes = data
      this.newCompetence = {}
      this.isEdit = false
      this.showModal = true
    },
    async updateCompetence() {
      if (!this.requiredFieldsFilled) {
        this.canCreate = false
        return
      }
      const {res} = await CompetenceService.updateCompetence(this.newCompetence._id, {
        competences_fr: this.newCompetence.competences_fr,
        competences_en: this.newCompetence.competences_en,
        competences_zh: this.newCompetence.competences_zh,
      });
      if (res.status !== 200) alert("Something went wrong");
      this.isEdit = false
      this.newCompetence = this.clearCompetence;
      this.showModal = false;
      await this.refreshTableData()
    },
    async createCompetence() {
      if (!this.requiredFieldsFilled) {
        this.canCreate = false
        return
      }
      const {res} = await CompetenceService.createCompetence({
        certification_code: this.newCompetence.certification_code,
        competences_fr: this.newCompetence.competences_fr,
        competences_en: this.newCompetence.competences_en,
        competences_zh: this.newCompetence.competences_zh,
      });
      if (res.status !== 201) alert("Something went wrong")
      else {
        this.showModal = false;
        await this.refreshTableData()
      }
      this.newFonction = this.clearCompetence;
    },
  }
}
</script>
